const KEY = "sk_blessing";
const SHOWN_KEY = "sk_blessing_shown";

export const TRADITIONS = ["buddhist", "christian", "hindu", "none"];

// Bilingual, faith-specific evening blessings. One rotates in each day.
export const BLESSINGS = {
  buddhist: [
    { si: "තෙරුවන් සරණයි — සිත සන්සුන් වේවා.", en: "May the Triple Gem bless you; may your mind be at peace.", ta: "திரிரத்தினம் உங்களை ஆசீர்வதிக்கட்டும்; மனம் அமைதி பெறட்டும்.", hi: "त्रिरत्न आपको आशीर्वाद दें; आपका मन शांत रहे।" },
    { si: "සියලු සත්වයෝ සුවපත් වෙත්වා.", en: "May all beings be well and happy.", ta: "அனைத்து உயிர்களும் நலமும் மகிழ்வும் பெறட்டும்.", hi: "सभी प्राणी सुखी और स्वस्थ हों।" },
    { si: "මේ පහනේ එළියෙන් සිත නිවී යාවා.", en: "May this lamp's glow bring your heart to stillness.", ta: "இந்த விளக்கின் ஒளி உங்கள் இதயத்தை அமைதிப்படுத்தட்டும்.", hi: "इस दीप की आभा आपके हृदय को शांति दे।" },
    { si: "මෛත්‍රියෙන් රාත්‍රිය පහන් වේවා.", en: "May loving-kindness light your evening.", ta: "அன்பும் கருணையும் உங்கள் மாலையை ஒளிரச் செய்யட்டும்.", hi: "करुणा और मैत्री आपकी संध्या को उज्ज्वल करें।" },
  ],
  christian: [
    { si: "දෙවියන්ගේ ආශිර්වාදය මේ සැන්දෑවේ ඔබට වේවා.", en: "May God's blessing be upon you this evening.", ta: "இந்த மாலையில் இறைவனின் ஆசி உங்கள் மீது இருக்கட்டும்.", hi: "इस संध्या ईश्वर का आशीर्वाद आप पर हो।" },
    { si: "සමාදානය ඔබ සමඟ වේවා.", en: "May peace be with you.", ta: "சமாதானம் உங்களுடன் இருக்கட்டும்.", hi: "शांति आपके साथ रहे।" },
    { si: "ප්‍රභූගේ ආලෝකය ඔබ මඟ පෙන්වා දේවා.", en: "May the Lord's light guide your evening.", ta: "ஆண்டவரின் ஒளி உங்கள் மாலைக்கு வழிகாட்டட்டும்.", hi: "प्रभु का प्रकाश आपकी संध्या को राह दिखाए।" },
    { si: "ඔබේ හදවත සැනසිල්ලෙන් පිරේවා.", en: "May your heart be filled with quiet comfort.", ta: "உங்கள் இதயம் அமைதியான ஆறுதலால் நிறையட்டும்.", hi: "आपका हृदय शांत सांत्वना से भर जाए।" },
  ],
  hindu: [
    { si: "දිව්‍ය ආලෝකය ඔබට සාමය ගෙන එත්වා.", en: "May the divine light bring you peace this evening.", ta: "தெய்வீக ஒளி இந்த மாலையில் உங்களுக்கு அமைதியைக் கொண்டு வரட்டும்.", hi: "दिव्य प्रकाश इस संध्या आपको शांति दे।" },
    { si: "ඔබට සුබ සන්ධ්‍යාවක් වේවා.", en: "May your evening be blessed and serene.", ta: "உங்கள் மாலை ஆசியும் அமைதியும் பெறட்டும்.", hi: "आपकी संध्या मंगलमय और शांत हो।" },
    { si: "සියල්ලට සුබ සෙත වේවා.", en: "May there be peace and goodwill to all.", ta: "அனைவருக்கும் அமைதியும் நன்மையும் உண்டாகட்டும்.", hi: "सबका कल्याण हो, सबमें सद्भाव हो।" },
    { si: "ලෝකයේ සියල්ලෝ සුවපත් වෙත්වා — ලෝකා සමස්තා සුඛිනෝ භවන්තු.", en: "Lokah Samastah Sukhino Bhavantu — may all the worlds be happy.", ta: "லோகா ஸமஸ்தா ஸுகினோ பவந்து — உலகனைத்தும் மகிழட்டும்.", hi: "लोकाः समस्ताः सुखिनो भवन्तु — सारे संसार सुखी हों।" },
  ],
  none: [
    { si: "සන්සුන් සන්ධ්‍යාවක් වේවා.", en: "May you have a calm, peaceful evening.", ta: "உங்களுக்கு அமைதியான மாலை அமையட்டும்.", hi: "आपकी संध्या शांत और सुखद हो।" },
    { si: "මේ මිහිර ඔබට සැනසිල්ලක් වේවා.", en: "May this music bring you comfort tonight.", ta: "இந்த இசை இன்றிரவு உங்களுக்கு ஆறுதலைத் தரட்டும்.", hi: "यह संगीत आज रात आपको सुकून दे।" },
    { si: "දවසේ වෙහෙස පහන් එළියේ දියවී යාවා.", en: "Let the day's weariness melt in the lamplight.", ta: "நாளின் களைப்பு விளக்கொளியில் கரையட்டும்.", hi: "दिन की थकान दीप की रोशनी में घुल जाए।" },
    { si: "ලොවේ සැමට යහපත සහ සාමය උදාවේවා!", en: "May goodness and peace come to all in the world!", ta: "உலகில் அனைவருக்கும் நன்மையும் அமைதியும் உதயமாகட்டும்!", hi: "संसार में सबके लिए भलाई और शांति का उदय हो!" },
  ],
};

export function getSettings() {
  const def = { name: "", tradition: "none", time: "18:00", enabled: true };
  try { return { ...def, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; }
  catch (e) { return def; }
}

export function saveSettings(s) {
  localStorage.setItem(KEY, JSON.stringify(s));
}

function dayIndex() {
  const d = new Date();
  return Math.floor((d - new Date(d.getFullYear(), 0, 0)) / 86400000);
}

export function blessingLine(tradition, lang) {
  const arr = BLESSINGS[tradition] || BLESSINGS.none;
  const item = arr[dayIndex() % arr.length];
  return item[lang] || item.en;
}

export function greeting(settings, lang) {
  const name = (settings.name || "").trim();
  const suffix = name ? `, ${name}` : "";
  if (lang === "si") return `සුබ සන්ධ්‍යාවක්${suffix}`;
  if (lang === "ta") return `இனிய மாலை வணக்கம்${suffix}`;
  if (lang === "hi") return `शुभ संध्या${suffix}`;
  return `Subha Sandhyawak${suffix}`;
}

export function isEveningWindow(settings) {
  const [h, m] = (settings.time || "18:00").split(":").map(Number);
  const now = new Date();
  return now.getHours() * 60 + now.getMinutes() >= h * 60 + m;
}

function todayStr() { return new Date().toISOString().slice(0, 10); }

export function shouldAutoShow(settings) {
  if (!settings.enabled) return false;
  if (!isEveningWindow(settings)) return false;
  return localStorage.getItem(SHOWN_KEY) !== todayStr();
}

export function markShown() { localStorage.setItem(SHOWN_KEY, todayStr()); }

function hash(str) { let h = 0; for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0; return h; }

// A calm, day-stable playlist (~8 tracks), preferring the "calm" tag.
export function todaysLamp(songs) {
  if (!songs || !songs.length) return [];
  const calm = songs.filter((s) => (s.tags || []).includes("calm"));
  const base = calm.length ? calm : songs;
  const day = todayStr();
  return [...base]
    .map((s) => ({ s, k: hash(s.id + day) }))
    .sort((a, b) => a.k - b.k)
    .slice(0, Math.min(8, base.length))
    .map((x) => x.s);
}
